import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-seo-off-page-insights',
  templateUrl: './seo-off-page-insights.component.html',
  styleUrls: ['./seo-off-page-insights.component.css'],
})
export class SeoOffPageInsightsComponent implements OnInit {
  metrics = {
    activeCampaigns: 0,
    prospectsPending: 0,
    prospectsPublished: 0,
    backlinksLive: 0,
    backlinksLost: 0,
    urlsWithoutSupport: 0,
    keywordsWithCampaigns: 0,
    citiesWithActiveCampaigns: 0,
  };

  loading = true;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.calculateMetrics();
  }

  calculateMetrics(): void {
    this.loading = true;

    const campaigns$ = this.dataService.getDataTwo('seoOffpageCampaigns', '', '', 1, 1000);
    const prospects$ = this.dataService.getDataTwo('seoOffpageProspects', '', '', 1, 1000);
    const backlinks$ = this.dataService.getDataTwo('seoBacklinks', '', '', 1, 1000);
    const registries$ = this.dataService.getDataTwo('seoRegistries', '', '', 1, 2000);

    forkJoin([campaigns$, prospects$, backlinks$, registries$]).subscribe(
      ([campaignsRes, prospectsRes, backlinksRes, registriesRes]) => {
        const campaigns = campaignsRes.data || [];
        const prospects = prospectsRes.data || [];
        const backlinks = backlinksRes.data || [];
        const registries = registriesRes.data || [];

        // 1. Active Campaigns
        const activeCampaigns = campaigns.filter((c: any) => 
          ['approved', 'in_progress'].includes(c.status)
        );
        this.metrics.activeCampaigns = activeCampaigns.length;

        // 2. Prospects Pending
        this.metrics.prospectsPending = prospects.filter((p: any) => 
          p.outreachStatus === 'pending'
        ).length;

        // 3. Prospects Published
        this.metrics.prospectsPublished = prospects.filter((p: any) => 
          p.outreachStatus === 'published'
        ).length;

        // 4. Backlinks Live
        this.metrics.backlinksLive = backlinks.filter((b: any) => 
          b.backlinkStatus === 'live'
        ).length;

        // 5. Backlinks Lost
        this.metrics.backlinksLost = backlinks.filter((b: any) => 
          b.backlinkStatus === 'lost'
        ).length;

        // 6. Keywords With Campaigns
        const keywords = new Set(campaigns.map((c: any) => c.targetKeyword).filter(Boolean));
        this.metrics.keywordsWithCampaigns = keywords.size;

        // 7. Cities With Active Campaigns
        const cities = new Set(activeCampaigns.map((c: any) => c.city).filter(Boolean));
        this.metrics.citiesWithActiveCampaigns = cities.size;

        // 8. URLs Without Off-Page Support
        const registryIdsWithCampaigns = new Set(campaigns.map((c: any) => String(c.registryId?._id || c.registryId)));
        this.metrics.urlsWithoutSupport = registries.filter((r: any) => 
          !registryIdsWithCampaigns.has(String(r._id))
        ).length;

        this.loading = false;
      },
      (error) => {
        console.error('Error calculating metrics', error);
        this.loading = false;
      }
    );
  }
}
